// 半角英数字(大文字小文字含む) 記号あり 6文字以上 空白なし 参考:https://codeclub965.com/?p=2038
export const validPasswordRegex = /^([a-zA-Z0-9!-/:-@¥[-`{-~]{6,})$/
export const isValidPassword = (password: string): boolean => validPasswordRegex.test(password)
